import Footer from "../Components/Footer";
import Header from "../Components/Header";

function ExamPolicy() {
    return (
        <>
            <Header />

            <section className="exam-policy" style={{animation:'fadeIn 1s ease-in-out'}}>
                <div className="container-fluid" style={{background:'#002147'}}>
                    <div className="row">
                        <div className="col-12">
                            <h4 className="text-center text-uppercase py-3" style={{color:'white', fontWeight:'bold'}}>Exam Policy</h4>
                        </div>
                    </div>
                </div>
                    <div className="container exam-policy">
                        <div className="row mx-auto">
                            <div className="col-12">

                            </div>
                            <div className="col-lg-10 " style={{ margin: 'auto' }}>
                                <table align="center" className="table table-bordered table-hover table-condensed" style={{ width: '100%', margin: 'auto' }}>
                                    <thead className="text-center">
                                        <tr>
                                            <th colSpan={2}>
                                                <h4>Examination Policy (Session: 2024-25)</h4>
                                            </th>
                                        </tr>
                                        <tr>
                                            <th colSpan={2}>
                                                <h4>SCHEME OF EXAMINATIONS AND EVALUATION</h4>
                                            </th>
                                        </tr>
                                        <tr>
                                            <th colSpan={2}>
                                                <h6>CLASSES : NURSERY, KG & PREP</h6>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td colSpan={2}>In Nursery, KG and Prep classes we emphasise on play-way and activity based teaching. Children are assessed on the basis of daily class performance and worksheets to be solved after a topic is over. Children are not graded at this stage. Report cards are given to the parents twice in a session for class Nursery and Prep. Teacher remains in regular contact with the parent to discuss the child's performance. <br /><br />

                                                Children are assessed on the basis of following:
                                            </td>
                                        </tr>
                                        <table align="center" className="table table-striped table-bordered table-hover table-condensed" style={{ margin: 'auto' }}>
                                            <tbody>
                                                <tr>
                                                    <td>1.</td>
                                                    <td>English</td>
                                                    <td>English	Reading, Writing, Speaking and Listening Skills.</td>
                                                </tr>
                                                <tr>
                                                    <td>2.</td>
                                                    <td>Mathematics</td>
                                                    <td>Counting, Number Value, Work Presentation & Activity.</td>
                                                </tr>
                                                <tr>
                                                    <td>3.</td>
                                                    <td>Environmental Science</td>
                                                    <td>General awareness, Activity Independence from adults, Confidence, Care of belongings, Neatness, Sharing & Caring, Initiative, Self-control.</td>
                                                </tr>
                                                <tr>
                                                    <td>4.</td>
                                                    <td>Curriculum Interests</td>
                                                    <td>Drawing & Colouring, Collage, Tearing & Pasting, Singing, Dancing, Rhymes and Stories, Games.</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </tbody>
                                </table>
                            </div>

                            <div className="col-lg-10 pt-5" style={{ margin: 'auto' }}>
                                <h3 className="text-center fw-bolder text-uppercase">EXAMINATION AND EVALUATION <br />
                                    Session : 2024-25 <br />
                                    Class : IX - X
                                </h3>
                                <table align="center" className="table-2 table table-striped table-bordered table-hover table-condensed" style={{ width: '100%', margin: 'auto' }}>
                                    <thead>
                                        <tr>
                                            <th style={{ width: '150px' }}></th>
                                            <th colSpan={4}>Total 100 Marks <br />
                                                (Syllabus for assessment for Class IX - X)
                                            </th>
                                        </tr>
                                        <tr>
                                            <th rowSpan={3}>Subjects</th>
                                            <th rowSpan={3}>80 Marks<br />
                                                (Annual/Board Exam)<br />
                                                Student has to secure
                                                33% marks out of 80 marks in each subject
                                            </th>
                                            <th colSpan={3}>20 Marks (Internal Assessment)<br />
                                                Student has to secure 33% marks out of overall 20 marks earmarked in each subject
                                            </th>
                                        </tr>
                                        <tr>
                                            <th>Periodic Test
                                                (10 Marks)
                                            </th>
                                            <th>Notebook Submission<br />
                                                (5 Marks)
                                            </th>
                                            <th>Subject
                                                Enrichment Activity
                                                (5 Marks)
                                            </th>
                                        </tr>
                                        <tr>
                                            <th>(i)</th>
                                            <th>(ii)</th>
                                            <th>(iii)</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Language 1</td>
                                            <td rowSpan={5}>Annual/Board will conduct Class IX-X Examination for 80 marks in each subject covering 100% syllabus of the subject of Class IX-X only. <br />

                                                Marks and Grades both will be awarded for Individual subjects. 9-point grading will be same as followed by the Board in Class XII.
                                            </td>
                                            <td rowSpan={5}>Periodic written Test, restricted to three in each subject in an Academic Year. <br />
                                                Average of the best two tests to be taken for final marks submission
                                            </td>
                                            <td rowSpan={5}>This is cover :
                                                <ul>
                                                    <li>Regularity</li>
                                                    <li>Assignment Completion</li>
                                                    <li>Neatness & upkeep of notebook</li>
                                                </ul>
                                            </td>
                                            <td>Speaking and listening skills</td>
                                        </tr>
                                        <tr>
                                            <td>Language 2</td>
                                            <td>Speaking and listening skills</td>
                                        </tr>
                                        <tr>
                                            <td>Science</td>
                                            <td>Practical Lab work</td>
                                        </tr>
                                        <tr>
                                            <td>Mathematics</td>
                                            <td>Maths Lab Practical</td>
                                        </tr>
                                        <tr>
                                            <td>Social Science</td>
                                            <td>Map work and Project Work</td>
                                        </tr>
                                        <tr>
                                            <td colSpan={5} className="fs-6">
                                                <b>1. 	Average of Best two of Periodic -1, Periodic -2 and Periodic - 3	:</b> 	10 Marks <br />
                                                <b>2. 	Notebook Submission :</b> 05 Marks <br />
                                                <b>3. 	Subject Enrichment Activity	:</b>  05 Marks <br />
                                                <b>4. 	Annual / Board Examination	:</b>	 80 Marks

                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div className="col-lg-8 col-12 pt-5" style={{ margin: 'auto' }}>
                                <h3 className="text-center fw-bolder text-uppercase fs-3">EXAMINATION AND EVALUATION <br />
                                    ASSESSMENT  SCHEDULE  Session : 2024-25 <br />
                                    Class : IX - X
                                </h3>
                                <h5 className="text-center fw-bolder text-uppercase pt-5">
                                    I - Term
                                </h5>
                                <table align="center" className="table table-striped table-bordered table-hover table-condensed" style={{ width: '100%', margin: 'auto' }}>
                                    <tbody>
                                        <tr>
                                            <td>I Periodic</td>
                                            <td>10</td>
                                        </tr>
                                        <tr>
                                            <td>Subject Enrichment Activity </td>
                                            <td>5</td>
                                        </tr>
                                        <tr>
                                            <td>Notebook Assessment</td>
                                            <td>5</td>
                                        </tr>
                                        <tr>
                                            <td>II Periodic</td>
                                            <td>10</td>
                                        </tr>
                                    </tbody>
                                </table>
                                <h5 className="text-center fw-bolder text-uppercase pt-5">
                                    ii - Term
                                </h5>
                                <table align="center" className="table table-striped table-bordered table-hover table-condensed" style={{ width: '100%', margin: 'auto' }}>
                                    <tbody>
                                        <tr>
                                            <td>III Periodic</td>
                                            <td>10</td>
                                        </tr>
                                        <tr>
                                            <td>Subject Enrichment Activity </td>
                                            <td>5</td>
                                        </tr>
                                        <tr>
                                            <td>Notebook Assessment</td>
                                            <td>5</td>
                                        </tr>
                                        <tr>
                                            <td>Annual Exam/Pre-Board Exam (X)</td>
                                            <td>80</td>
                                        </tr>
                                    </tbody>
                                </table>
                                <table align="center" className="table table-striped table-bordered table-hover table-condensed mt-5" style={{ width: '100%', margin: 'auto' }}>
                                    <tbody>
                                        <tr>
                                            <td className="fw-bolder">I, II and III Periodic Test</td>
                                            <td >
                                                Weightage given	     <span>=	10% </span><br />
                                                Marks alloted	=	50 Marks
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="fw-bolder">Subject Enrichment Activity </td>
                                            <td>
                                                Weightage given	=	5% <br />
                                                Marks alloted	=	20 Marks
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="fw-bolder">Notebook Assessment</td>
                                            <td>
                                                Weightage given	=	5% <br />
                                                Marks alloted	=	5, 4, 3, 2, 1 Marks
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="fw-bolder">Pre-Board (X) / Annual Exam (IX)</td>
                                            <td>
                                                Weightage given	=	80% <br />
                                                Marks alloted	=	80 Marks
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div className="col-lg-10 col-12 pt-3" style={{ margin: 'auto' }}>
                                <p className="fs-5" style={{ textAlign: 'justify', fontFamily: 'Cantarell' }}>Students using unfair means during weekly test / Peiodic Test / Half Yearly / Annual Examination will be marked zero in that subject and asked to leave the school after the session. No retest will be held for such students. These students will not be eligible for any academic awards or school appointment.</p>
                            </div>

                            <div className="col-lg-10 col-12 pt-5" style={{ margin: 'auto' }}>
                                <h3 className="text-center fw-bolder text-uppercase fs-3">
                                    Class : XI <br />
                                    Session : 2024-25
                                </h3>
                                <p className="fs-5 ps-lg-5" style={{ textAlign: 'justify', fontFamily: 'Cantarell' }}>The academic year 2019-2020 will be divided into two terms and examination will be held at the end of the each term.</p>
                                <table align="center" className="table-3 table table-striped table-bordered table-hover table-condensed" style={{ margin: 'auto' }}>
                                    <thead>
                                        <tr>
                                            <th colSpan={2}>TERM - I</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className="ps-lg-5">Monday Test I </td>
                                            <td>= 5%</td>
                                        </tr>
                                        <tr>
                                            <td className="ps-lg-5">Monday Test II </td>
                                            <td>= 5%</td>
                                        </tr>
                                        <tr>
                                            <td className="ps-lg-5">Half Yearly </td>
                                            <td>= 40%</td>
                                        </tr>
                                    </tbody>
                                </table>
                                <table align="center" className="table-3 table table-striped table-bordered table-hover table-condensed mt-5" style={{ margin: 'auto' }}>
                                    <thead>
                                        <tr>
                                            <th colSpan={2}>TERM - II</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className="ps-lg-5" style={{ width: '65%' }}>Monday Test III</td>
                                            <td> = 5%</td>
                                        </tr>
                                        <tr>
                                            <td className="ps-lg-5">Monday Test IV</td>
                                            <td> = 5%</td>
                                        </tr>
                                        <tr>
                                            <td className="ps-lg-5">Annual Exam </td>
                                            <td> = 40%</td>
                                        </tr>
                                        <tr>
                                            <td className="ps-lg-5">Monday Test - 1+2+3+4 </td>
                                            <td> = 20%</td>
                                        </tr>
                                        <tr>
                                            <td className="ps-lg-5">Half Yearly + Annual </td>
                                            <td> = 80%</td>
                                        </tr>
                                    </tbody>
                                </table>

                                <div className="pt-5" style={{ fontFamily: 'Cantarell' }}>
                                    <h5 className="fs-4 fw-bolder text-uppercase" style={{ textAlign: 'justify' }}>Monday Test : -</h5>
                                    <ol className="fs-5">
                                        <li>Monday Test will be held in all the subjects, for classes, XI and XII, according to the schedule, 	which is given in the Almanac.</li>
                                        <li>Monday Tests are compulsory for all the students for classes XI and XII. A medical certificate for 	absence has to be given to the Examination Department, failing which the student will be given zero.</li>
                                        <li>The retest for such students will be held on the Saturday of the same week.</li>
                                        <li>A student will be given two chances to appear for re-test in a year.</li>
                                        <li>No Re-Exam of Term/Halfyearly/Annual Exam.</li>
                                    </ol>

                                    <h5 className="fs-4 fw-bolder text-uppercase" style={{ textAlign: 'justify' }}>PROMOTION  : -</h5>
                                    <ul className="fs-5">
                                        <li>For class XI the student should get passing marks in the theory and the practical examination separately.</li>
                                    </ul>

                                    <h5 className="fs-4 fw-bolder text-uppercase" style={{ textAlign: 'justify' }}>COMPARTMENT   : -</h5>
                                    <ul className="fs-5">
                                        <li>For class XI a clear pass (33%) in all the subjects and atleast <b>30%</b> in the subject failed in. The compartment exams will be held in the first week of April.</li>
                                    </ul>

                                    <h5 className="fs-4 fw-bolder text-uppercase" style={{ textAlign: 'justify' }}>FAILED    : -</h5>
                                    <ul className="fs-5">
                                        <li>If a student fails in two or more subjects (if five subject combination)</li>
                                        <li>If a student fails in three or more subjects (if six subject combination)</li>
                                    </ul>

                                    <p className="fs-5" style={{ textAlign: 'justify', fontFamily: 'Cantarell' }}>Students using unfair means during weekly test / Peiodic Test / Half Yearly / Annual Examination will be marked zero in that subject and asked to leave the school after the session. No retest will be held for such students. These students will not be eligible for any academic awards or school appointment.</p>
                                </div>
                            </div>
                        </div>
                    </div>
            </section>
            <Footer />
        </>
    )
}

export default ExamPolicy;